// Sticky header scroll behavior
(function() {
  var scrolled = false;
  window.addEventListener('scroll', function() {
    if (window.scrollY > 60 && !scrolled) {
      document.body.classList.add('sol-scrolled');
      scrolled = true;
    } else if (window.scrollY <= 10 && scrolled) {
      document.body.classList.remove('sol-scrolled');
      scrolled = false;
    }
  }, { passive: true });
})();
